<template>
	<div class="model1">
		<div class="m1_top_box">
			<div class="m1_echarts1" id="m1_echarts1"></div>
			<div class="m1_echarts_alert" id="m1_echarts_alert"></div>
			<span class="m1_echarts_bar_close">X</span>
		</div>
		<!-- 文章列表部分 -->
		<div class="m1_info_box">
			<div class="m1_search_box">
				<el-cascader
					style="border:1px solid #E7EDE5;border-radius:4px;"
					:options="options"
					@change="changeAreaFn"
					v-model="regionIds"
					:props="props2"
					collapse-tags
					filterable
					clearable
				>
				</el-cascader>
				<el-date-picker
					@change="changeDateFn"
					style="width:250px;border: 1px solid #F3F3F3;margin-left:12px;"
					size="large"
					v-model="dateRaneg"
					unlink-panels
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
				>
				</el-date-picker>
				<div @click="downloadTable" class="m1_download_data">
					导出数据
				</div>
			</div>
			<ul class="m1_info_ul">
				<el-table
					v-loading="loading"
					element-loading-text="加载中"
					:empty-text="loading == true ? '加载中' : '暂无数据'"
					:fit="true"
					style="width:100%;margin:20px auto;"
					:data="dataList"
					:header-cell-style="headerCellStyle"
					:row-style="tableRowClassName"
					:cell-style="cellStyle"
					border
				>
					<el-table-column
						v-for="(item, index) in dataList[0]"
						:prop="index"
						:label="item"
						:show-overflow-tooltip="true"
						:sortable="false"
						align="center"
						:key="index"
						:min-width="
							tableColumnWidth[index] < 24
								? tableColumnWidth[index] * 16
								: tableColumnWidth[index] * 8
						"
					>
					</el-table-column>
				</el-table>
				<el-empty
					v-if="dataList.length <= 0 && loading == false"
					description="暂无数据!"
				></el-empty>
				<el-empty
					v-if="loading == true"
					description="加载中!"
				></el-empty>
			</ul>
			<div v-if="currentSource" style="font-size: 14px; float: right;">
				来源：{{ currentSource }}
			</div>
			<div class="pagination_box">
				<el-pagination
					v-if="dataList.length > 0"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-size="pagesize"
					layout="total, prev, pager, next, jumper"
					:total="total"
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';
// import echarts from 'echarts';
import echarts from '@/../static/plugins/echarts/echarts.js';
import axios from 'axios';

export default {
	// 能源展示数据--全国各省
	props: ['currentChoose', 'regionLevel', 'currentSource'],
	components: {},
	data() {
		return {
			dateRaneg: [], //日期
			startDate: '', //日历开始时间
			endDate: '', //日历结束时间
			dataType: '', //时间选项 0是 一周 1 是一个月 2 是一年 不限 ''
			currentPage: 1, //当前页
			total: 0, //总页数
			pagesize: 10, //每页条数
			dataList: [], //文章列表数据
			tableColumnWidth: [], //表格各个列最大宽度
			loading: false, //表格加载
			props2: { multiple: true }, //选择器数据
			regionIds: '', //当前传值选中的地区
			options: [
				{
					value: 1,
					label: '东南',
					children: [
						{
							value: 2,
							label: '上海',
							children: [
								{ value: 3, label: '普陀' },
								{ value: 4, label: '黄埔' },
								{ value: 5, label: '徐汇' },
							],
						},
					],
				},
				{
					value: 17,
					label: '西北',
					children: [
						{
							value: 18,
							label: '陕西',
							children: [
								{ value: 19, label: '西安' },
								{ value: 20, label: '延安' },
							],
						},
					],
				},
			],
			maps: {
				bigNum: 0, //当前地图数据里的最大值
			},
		};
	},
	watch: {
		currentChoose(val) {
			this.regionIds = '';
			this.currentPage = 1;
			this.fetchDataList(val); //获取文章列表
			this.fetchAreaDataList(val);
			this.echartsfn1();
			this.echartsfn2('北京'); //每次进来默认展示北京数据

			$('.m1_echarts_alert').css('display', 'block');
			$('.m1_echarts_bar_close').css('display', 'block');
		},
		//时间段清零函数
		dateRaneg(val) {
			if (val == null) {
				this.startDate = '';
				this.endDate = '';

				this.currentPage = 1;
				this.fetchDataList(this.currentChoose);
			}
			//console.log(val, 'test');
		},
	},
	computed: {},
	created() {
		$('.el-range-editor.el-input__inner').css(
			'border',
			'1px solid #F3F3F3!important'
		);
	},
	mounted() {
		setTimeout(() => {
			$('.el-range-editor--small.el-input__inner').css(
				'border',
				'1px solid #F3F3F3'
			);
			$('.el-pagination__editor.el-input .el-input__inner').css(
				'border',
				'1px solid #E6E6E6!important'
			);
			$('.el-range-editor.el-input__inner').css(
				'border',
				'1px solid #F3F3F3!important'
			);
		}, 2000);

		this.fetchDataList(this.currentChoose);
		this.fetchAreaDataList(this.currentChoose);

		this.echartsfn1();
		setTimeout(() => {
			this.echartsfn2('北京'); //每次进来默认展示北京数据
		}, 200);
	},
	methods: {
		//点击下载按钮
		downloadTable() {
			let _this = this;
			let tmp_regionIds = [
				...new Set(this.regionIds.toString().split(',')),
			].toString();
			let params = {
				indexId: _this.currentChoose,
				pagesize: this.pagesize,
				curpage: this.currentPage,
				start: this.startDate,
				end: this.endDate,
				regionIds: tmp_regionIds,
				type: '0',
			};

			axios({
				method: 'post',
				url: window.normalUrl + '/down/downDischargeData', // 请求地址
				data: params,
				responseType: 'arraybuffer',
				observe: 'response',
			}).then((res) => {
				const fileName = decodeURIComponent(
					res.headers['content-disposition']
						.split(';')[1]
						.split('=')[1]
				);
				let blob = new Blob([res.data], {
					type:
						'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				});
				// //console.log(decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('=')[1]),'blob');
				if ('download' in document.createElement('a')) {
					// 非IE下载
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
				} else {
					// IE10+下载
					navigator.msSaveBlob(blob, fileName);
					// navigator.msSaveBlob(blob);
				}
			});
		},
		//选中某个地区函数
		changeAreaFn(val) {
			// let str = '';
			// if(val.length > 0){
			//     for(let i=0;i<val.length;i++){
			//         if(val[i].length >= 1){
			//             str += val[i][val[i].length - 1] + ',';
			//         }
			//     }
			// }
			// this.regionIds = str;
			this.currentPage = 1;
			this.fetchDataList(this.currentChoose);
			// //console.log(str,'val-fn');
		},
		//table的单元格样式
		cellStyle(row, column, rowIndex, columnIndex) {
			//styles
			let _this = this;
			if (row.rowIndex % 2 == 0 && row.rowIndex > 0) {
				return 'background:#F5F7F5;';
			}
			if (row.rowIndex == 0) {
				return 'color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;display:none;';
			}
		},
		//获取表格每一列的文字最大长度
		getMaxTableWidthFn(data) {
			let _this = this;
			let tmpLen = Object.keys(data[0]).length;
			let arr = [];
			for (let i = 0; i < tmpLen; i++) {
				arr.push([]);
			}
			for (let i = 0; i < data.length; i++) {
				for (let item in data[i]) {
					let len = _this.chkstrlen(String(data[i][item]));
					arr[item].push(len);
				}
			}
			_this.tableColumnWidth = [];
			for (let i = 0; i < arr.length; i++) {
				_this.tableColumnWidth.push(Math.max(...arr[i]));
			}
		},
		//判断是否是汉字
		chkstrlen(str) {
			let strlen = 0;
			for (let i = 0; i < str.length; i++) {
				if (str.charCodeAt(i) > 255) {
					//如果是汉字，则字符串长度加2
					strlen += 2;
				} else {
					strlen++;
				}
			}
			return strlen;
		},
		// table表格样式
		headerCellStyle({ row, rowIndex }) {
			return 'background:#F5F7F5;color:#222222;';
		},
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 0) {
				return 'background:#F5F7F5!important;';
			}
			return '';
		},
		// 中国地图
		echartsfn1() {
			let _this = this;
			//地图容器
			let chart = echarts.init(document.getElementById('m1_echarts1'));
			//34个省、市、自治区的名字拼音映射数组
			let provinces = {
				//23个省
				台湾: 'taiwan',
				河北: 'hebei',
				山西: 'shanxi',
				辽宁: 'liaoning',
				吉林: 'jilin',
				黑龙江: 'heilongjiang',
				江苏: 'jiangsu',
				浙江: 'zhejiang',
				安徽: 'anhui',
				福建: 'fujian',
				江西: 'jiangxi',
				山东: 'shandong',
				河南: 'henan',
				湖北: 'hubei',
				湖南: 'hunan',
				广东: 'guangdong',
				海南: 'hainan',
				四川: 'sichuan',
				贵州: 'guizhou',
				云南: 'yunnan',
				陕西: 'shanxi1',
				甘肃: 'gansu',
				青海: 'qinghai',
				//5个自治区
				新疆: 'xinjiang',
				广西: 'guangxi',
				内蒙古: 'neimenggu',
				宁夏: 'ningxia',
				西藏: 'xizang',
				//4个直辖市
				北京: 'beijing',
				天津: 'tianjin',
				上海: 'shanghai',
				重庆: 'chongqing',
				//2个特别行政区
				香港: 'xianggang',
				澳门: 'aomen',
			};

			//直辖市和特别行政区-只有二级地图，没有三级地图
			let special = ['北京', '天津', '上海', '重庆', '香港', '澳门'];
			let mapdata = [];
			chart.off('click'); //解决点击事件点击一次调用多次的问题

			//绘制全国/地区地图
			loadChinaMap();

			function loadChinaMap() {
				$.getJSON(
					'@/../static/plugins/chinese-map/static/map/updated_china5.geojson',
					function(data) {
						// //console.log(data,'dataaaaaa')

						//获取当前地图数据值
						let params = { indexId: _this.currentChoose };
						api.getGraphMapData2(params).then((res) => {
							//console.log(res, 'd');

							let d = res.data ? res.data.data : [];

							let unitName = res.data ? res.data.unitName : ''; //单位
							let date = res.data ? res.data.date : ''; //日期

							_this.maps.bigNum = 0;

							if (d.length > 0) {
								for (let i = 0; i < d.length; i++) {
									d[i].value > _this.maps.bigNum
										? (_this.maps.bigNum = d[i].value)
										: ''; //获取最大值
								}
							}

							mapdata = d;
							// $('.m1_echarts1').css('display', 'none');
							//注册地图
							echarts.registerMap('china', data);

							//绘制地图
							renderMap('china', d, unitName, date);
						});
					}
				);
			}

			//地图点击事件
			chart.off('click');
			chart.on('click', function(params) {
				$('.m1_echarts_alert').css('display', 'block');
				$('.m1_echarts_bar_close').css('display', 'block');
				// //console.log(params,'params');
				params.data && params.data.name
					? _this.echartsfn2(params.data.name)
					: '';
			});

			$('.m1_echarts_bar_close').off('click');
			$('.m1_echarts_bar_close').on('click', function(params) {
				$('.m1_echarts_bar_close').css('display', 'none');
				$('.m1_echarts_alert').css('display', 'none');
			});

			var fullName = {
				北京: '北京市',
				天津: '天津市',
				河北: '河北省',
				山西: '山西省',
				内蒙古: '内蒙古自治区',
				辽宁: '辽宁省',
				吉林: '吉林省',
				黑龙江: '黑龙江省',
				江苏: '江苏省',
				浙江: '浙江省',
				安徽: '安徽省',
				福建: '福建省',
				江西: '江西省',
				山东: '山东省',
				河南: '河南省',
				湖北: '湖北省',
				湖南: '湖南省',
				广东: '广东省',
				广西: '广西壮族自治区',
				海南: '海南省',
				四川: '四川省',
				贵州: '贵州省',
				云南: '云南省',
				西藏: '西藏自治区',
				陕西: '陕西省',
				甘肃: '甘肃省',
				青海: '青海省',
				重庆: '重庆市',
				宁夏: '宁夏回族自治区',
				新疆: '新疆维吾尔自治区',
				香港: '香港特别行政区',
				澳门: '澳门特别行政区',
				台湾: '台湾省',
			};
			//初始化绘制全国地图配置
			var option = {
				// backgroundColor: '#fff',
				title: {
					show: false,
					text: '',
					subtext: '',
					left: 'center',
					textStyle: {
						color: '#121212',
						fontSize: 16,
						fontWeight: 'normal',
						fontFamily: 'Source Han Sans CN',
					},
					subtextStyle: {
						color: '#121212',
						fontSize: 13,
						fontWeight: 'normal',
						fontFamily: 'Source Han Sans CN',
					},
				},
				grid: {
					//设置canvas内部表格的内距
					x: 50,
					y: 50,
					x2: 50,
					y2: 0,
					borderWidth: 10,
				},
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: '{b}： {c}家',
				},
				toolbox: {
					show: false,
					orient: 'vertical',
					left: 'right',
					top: 'top',
					iconStyle: {
						normal: {
							color: '#fff',
						},
					},
					feature: {
						mark: {
							// '辅助线开关'
							show: true,
						},
						saveAsImage: {
							//保存为图片。
							show: true, //是否显示该工具。
							type: 'png', //保存的图片格式。支持 'png' 和 'jpeg'。
							name: 'pic1', //保存的文件名称，默认使用 title.text 作为名称
							backgroundColor: '#ffffff', //保存的图片背景色，默认使用 backgroundColor，如果backgroundColor不存在的话会取白色
							title: '中国地图',
							pixelRatio: 1, //保存图片的分辨率比例，默认跟容器相同大小，如果需要保存更高分辨率的，可以设置为大于 1 的值，例如 2
						},
						// dataView: {readOnly: false},
					},
				},
				geo: {
					map: 'china',
					roam: true,
					zoom: 1.6,
					center: [104.46, 35.92],

					label: {
						normal: {
							show: true,
							formatter: function(param) {
								var reName = '';
								if (
									param.name == '香港' ||
									param.name == '澳门'
								) {
									reName = '';
								} else {
									if (fullName[param.name]) {
										reName = fullName[param.name];
									} else {
										reName = '';
									}
								}
								return reName;
							},
							textStyle: {
								color: '#000',
								fontSize: 12,
							},
						},
						emphasis: {
							show: true,
							textStyle: {
								color: '#640000',
								fontSize: 13,
							},
						},
					},
					itemStyle: {
						normal: {
							// borderColor: 'rgba(147, 235, 248, 1)',
							borderColor: '#9c978b',
							borderWidth: 1,
							areaColor: {
								type: 'radial',
								x: 0.2,
								y: 0.2,
								r: 0.9,
								colorStops: [
									{
										offset: 0,
										color: 'rgba(255, 255, 255, 0)', // 0% 处的颜色
									},
									{
										offset: 1,
										color: 'rgba(255, 255, 255, .1)', // 100% 处的颜色
									},
								],
								globalCoord: false, // 缺省为 false
							},

							// shadowColor: 'rgba(128, 217, 248, 1)',
							// shadowColor: '#043563',
							// shadowOffsetX: -2,
							// shadowOffsetY: 2,
							// shadowBlur: 10
						},
						emphasis: {
							areaColor: '#ffdf33',
							borderWidth: 0,
						},
					},
				},
				animationDuration: 1000,
				animationEasing: 'cubicOut',
				animationDurationUpdate: 1000,
				visualMap: {
					min: 0,
					max: 150,
					right: '0',
					bottom: '2px',
					text: ['高', '低'],
					calculable: true,
					// seriesIndex: [1],
					inRange: {
						// color: ['#D2EAFF', '#177FE8']
						color: ['#ebdecb', '#8aa87d', '#7d97a8'],
					},
					show: true,
					textStyle: {
						color: ['transparent'],
					},
				},
			};

			function renderMap(map, data, unitName, date) {
				option.visualMap.max = _this.maps.bigNum + 5;
				option.title.subtext = map;
				option.tooltip.formatter = function(params) {
					if (params.value) {
						return date + '：' + params.value + unitName;
					}
				};
				option.series = [
					{
						name: map,
						type: 'map',
						geoIndex: 0, // 关联到上面的 geo 配置
						data: data,
					},
					{
						name: '引导线',
						type: 'lines',
						zlevel: 3,
						lineStyle: {
							normal: {
								color: 'rgb(36, 36, 36)',
								width: 1,
								type: 'solid',
							},
						},
						data: [
							{
								coords: [
									[114.16, 22.28],
									[116.87, 22.18],
								], // 香港引导线
								label: {
									show: true,
									position: 'end',
									formatter: '香港特别行政区',
									color: '#000',
								},
							},
							{
								coords: [
									[113.55, 22.14],
									[113.27, 21.05],
								], // 澳门引导线
								label: {
									show: true,
									position: 'end',
									formatter: '澳门特别行政区',
									color: '#000',
								},
							},
						],
					},
				];
				//渲染地图
				chart.setOption(option, true);
			}
		},
		// 柱状图
		echartsfn2(name) {
			var chartDom = document.getElementById('m1_echarts_alert');
			var myChart = echarts.init(chartDom);

			var option = {
				color: ['#42A15B'],
				title: {
					text: 'aaaaaaaaa',
					left: 'center',
					textStyle: { fontSize: 14, fontWeight: 'normal' },
				},
				grid: {
					left: '2%',
					right: '8%',
					bottom: '6%',
					top: '12%',
					containLabel: true,
				},
				tooltip: {
					show: true,
					trigger: 'axis',
					formatter: '{b}： {c}',
				},
				xAxis: {
					type: 'category',
					data: [],

					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						interval: 3,
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				series: [
					{
						data: [],
						type: 'bar',
						barWidth: 10,
						showBackground: true,
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)',
						},
					},
				],
			};

			let params = { indexId: this.currentChoose, regionName: name };

			api.getGraphBarMapData2(params).then((res) => {
				option.series[0].data = res.data.xList.reverse();
				option.xAxis.data = res.data.yList.reverse();
				option.tooltip.formatter =
					'{b}： {c}' + (res.data.unitName ? res.data.unitName : '');
				option.title.text = res.data.title;
				//console.log(option, 'option');
				// setTimeout(()=>{
				if (res.data.xList.length > 0) {
					option && myChart.setOption(option);
				} else {
					$('.m1_echarts_alert').css('display', 'none');
					$('.m1_echarts_bar_close').css('display', 'none');
				}
				// },400);
			});
		},
		// 点击日历切换函数
		changeDateFn(res) {
			if (this.dateRaneg.length > 0) {
				let startDate = magic.TimestampToDateTime(res[0]);
				let endDate = magic.TimestampToDateTime(res[1]);

				startDate
					? (this.startDate = startDate.substring(0, 10))
					: (this.startDate = '');
				endDate
					? (this.endDate = endDate.substring(0, 10))
					: (this.endDate = '');

				this.currentPage = 1;
				this.fetchDataList(this.currentChoose);
			}
		},
		//获取表格数据
		fetchDataList(_id) {
			let _this = this;
			//type，0：全国，1：全球
			let tmp_regionIds = [
				...new Set(this.regionIds.toString().split(',')),
			].toString();
			//console.log(tmp_regionIds, 'this.regionIds');
			let params = {
				indexId: _id,
				pagesize: this.pagesize,
				curpage: this.currentPage,
				start: this.startDate,
				end: this.endDate,
				regionIds: tmp_regionIds,
				type: '0',
			};
			this.loading = true;
			api.getGraphListData3(params).then((res) => {
				//console.log(res, 'list');

				_this.dataList = res.data.rows;
				_this.getMaxTableWidthFn(res.data.rows);
				_this.total = res.data.total;
				setTimeout(() => {
					_this.loading = false;
				}, 100);
			});
		},
		//获取地区选项数据
		fetchAreaDataList(_id) {
			var _id =
				this.regionLevel == '' || this.regionLevel == null
					? 1
					: this.regionLevel;
			let _this = this;
			api.getRegionList(_id).then((res) => {
				//console.log(res, 'area');
				_this.options = res.data;
			});
		},
		//翻页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fetchDataList(this.currentChoose);
		},
	},
	filters: {
		subData1: function(value) {
			return value.substring(0, 7);
		},
		subData2: function(value) {
			return value.substring(8, 10);
		},
	},
};
</script>
<style scoped lang="less">
.model1 {
	width: 890px;
	height: 100%;
	overflow: hidden;
	padding: 14px 30px;
	background: #fff;
}

.m1_top_box {
	width: 100%;
	overflow: hidden;
	position: relative;
}

.m1_echarts_box {
	width: 100%;
	overflow: hidden;
	margin-top: 85px;
}
.m1_echarts1 {
	width: 890px;
	// height: 560px;
	height: 637px;
	float: left;
	background: radial-gradient(circle, #f5f7f5, #d9dbd9);
	margin-top: 17px;
}
.m1_echarts_alert {
	// width: 313px;
	width: 320px;
	height: 196px;
	background: #ffffff;
	border: 1px solid #dbdbdb;
	box-shadow: 0px 0px 27px 0px rgba(190, 193, 189, 0.75);
	border-radius: 2px;
	position: absolute;
	bottom: 0;
	left: 0;
	z-index: 1000;
	// display: none;
}
.m1_echarts_bar_close {
	position: absolute;
	bottom: 181px;
	left: 299px;
	display: block;
	width: 25px;
	height: 25px;
	border: 1px solid #ccc;
	z-index: 2000;
	text-align: center;
	line-height: 26px;
	border-radius: 50%;
	background: #fff;
	cursor: pointer;
}
//文章列表部分
.m1_info_box {
	width: 100%;
	overflow: hidden;
	position: relative;
}
.m1_info_box h5 {
	width: 100%;
	height: 70px;
	line-height: 70px;
	border-bottom: 1px solid #e7ede5;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	margin-top: 30px;
}
.m1_info_box h5 img {
	height: 18px;
	display: inline-block;
	margin-right: 5px;
	vertical-align: middle;
}
// 搜索框部分
.m1_search_box {
	width: 100%;
	line-height: 32px;
	margin-top: 22px;
	overflow: hidden;
}
.m1_download_data {
	width: 100px;
	height: 36px;
	background: #4eac41;
	border-radius: 1px;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #ffffff;
	text-align: center;
	line-height: 36px;
	display: inline-block;
	float: right;
	cursor: pointer;
}

.el-range-editor.el-input__inner {
	border: 1px solid #e7ede5 !important;
}
.m1_info_ul {
	width: 100%;
	overflow: hidden;
	margin-top: 16px;
}

// table样式
.el-table .row_yellow {
	background: #f5f7f5 !important;
}

// 分页
.pagination_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 70px;
	margin-top: 50px;
	text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/discolumn/mode6.vue